import { DocTypes, Gender, TravellerProfileFragment, UserProfile } from '@websky/graphql';

export interface TravellerType extends TravellerProfileFragment {
	preferredDepPoints?: UserProfile['preferredDepPoints'];
	preferredArrPoints?: UserProfile['preferredArrPoints'];
}

export interface TravellerFormType {
	firstName?: string;
	lastName?: string;
	middleName?: string;
	nationality?: string;
	birthDate?: string;
	gender?: Gender;
	email?: string;
	phone?: string;
	loyaltyNumber?: string[];
	documents?: DocumentType[];
	/** Поля для хранения выбранных направлений */
	departure?: DropdownOption[];
	arrival?: DropdownOption[];
	/** Поля для хранения значения инпута, для поиска в Dropdown */
	departureQuery?: string;
	arrivalQuery?: string;
}

export interface DocumentType {
	firstName?: string;
	lastName?: string;
	middleName?: string;
	docNumber?: string;
	docExpiryDate?: string;
	docType?: DocTypes;
	citizenship?: string;
}

export interface TravellerFieldSets {
	latinNames?: string[];
	originalNames?: string[];
	personInfo?: string[];
	accountInfo?: string[];
}

export interface DropdownOption {
	label: string;
	value: string;
}

export interface DocumentsMutatorArgs {
	type: 'add' | 'remove';
	index?: number;
}

export interface ValueMutatorArgs {
	fieldName: string;
}

export interface DocumentValueMutatorArgs extends ValueMutatorArgs {
	index: number;
}

export type DirectionsFieldName = Extract<keyof TravellerFormType, 'departure' | 'arrival'>;
export type DirectionsAction = 'add' | 'delete';
export type DirectionsMutatorArgs = [DirectionsFieldName, DropdownOption, DirectionsAction];
export interface MutatorArgs {
	index: number;
}

export enum FormStages {
	Default,
	Loading,
	Success
}

export enum TravellerFields {
	BirthDate = 'birthDate',
	Gender = 'gender',
	Phone = 'phone',
	Email = 'email',
	Documents = 'documents',
	/** Поля для хранения выбранных направлений */
	Departure = 'departure',
	Arrival = 'arrival',
	/** Поля для хранения значения инпута, для поиска в Dropdown */
	DepartureQuery = 'departureQuery',
	ArrivalQuery = 'arrivalQuery',

	// TODO: remove later, needed for back compatibility
	Nationality = 'nationality',
	FirstName = 'firstName',
	LastName = 'lastName',
	MiddleName = 'middleName'
}

export enum TravellerDocumentFields {
	FirstName = 'firstName',
	LastName = 'lastName',
	MiddleName = 'middleName',
	DocNumber = 'docNumber',
	DocExpiryDate = 'docExpiryDate',
	DocType = 'docType',
	Nationality = 'nationality',
	Citizenship = 'citizenship'
}
